import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { ROUTES, resolveSidebarLabel } from "@/constants";
import { useTranslation } from "@/context/I18nProvider";
import { useAdminSidebars, useDocumentTitle } from "@/hooks";

// Strips the leading "403 - " / "404 - " status-code prefix used in the
// on-page heading, which reads awkwardly repeated in a browser tab title.
const stripStatusPrefix = (label: string) => label.replace(/^\d+\s*-\s*/, "");

// Sets the browser tab title to "SkyStake {page name}" for every route
// rendered inside the authenticated Layout. Most pages are driven by the
// DB-backed sidebar (matched by exact pathname, same as NavbarBreadcrumbs),
// with a few statics for routes that aren't sidebar entries themselves.
export default function PageTitle() {
  const { t } = useTranslation();
  const location = useLocation();
  const rows = useAdminSidebars();

  const pageName = useMemo(() => {
    if (location.pathname === ROUTES.HOME) return t("nav.dashboard");
    if (location.pathname === ROUTES.USER_PROFILE) return t("common.profile");
    if (location.pathname === ROUTES.FORBIDDEN) return stripStatusPrefix(t("forbidden.title"));

    const row = rows.find((r) => r.url === location.pathname);
    return row ? resolveSidebarLabel(row.name, row.label, t) : "";
  }, [rows, location.pathname, t]);

  useDocumentTitle(pageName);

  return null;
}
